import CT from '@marketplace-ai/tags';
import { createElement } from 'react';
import { Column } from '~/components';
import type { MsaasJobListing } from '~/types/hlx/msaasJobListing';
import { b2bSideCopy } from '../../b2bSideCopy';
import { ListingStatusCell } from './ListingStatusCell';

const TAGS = CT.employer.msaasListings.table;

export const TABLE_COLUMNS: Column[] = [
  { label: 'Listing ID', data: 'id', sortKey: 'id', cyTag: 'id' },
  {
    label: 'Title',
    data: 'listingTitle',
    sortKey: 'listing_title',
    cyTag: TAGS.title,
  },
  {
    label: 'Work Location',
    data: 'workLocation',
    formatter: (data) => data.charAt(0) + data.slice(1).toLowerCase(),
    sortKey: 'work_location',
    cyTag: TAGS.workLocation,
  },
  {
    label: 'Active',
    data: (row) => (row.activeFlag ? 'Yes' : 'No'),
    sortKey: 'active_flag',
    cyTag: TAGS.activeFlag,
  },
  {
    label: 'Filled',
    data: (row) => (row.filledFlag ? 'Yes' : 'No'),
    sortKey: 'filled_flag',
    cyTag: TAGS.filledFlag,
  },
];

// [MCV-1889] With selling listings on, the table says which side each listing is on, and shows where
// it is in its life (cancelled, relisted, or filled by a contract) next to the Active / Filled flags.
export const OFFERING_TABLE_COLUMNS: Column[] = [
  TABLE_COLUMNS[0],
  {
    label: 'Side',
    data: (row) => b2bSideCopy(row.listingSide).sideLabel,
    cyTag: 'side',
  },
  ...TABLE_COLUMNS.slice(1),
  {
    label: 'Status',
    data: (row) => createElement(ListingStatusCell, { listing: row as MsaasJobListing }),
    cyTag: 'status',
  },
];
